<template>
  <md-dialog
    :md-active.sync="dialog"
    :md-click-outside-to-close="false"
    :md-close-on-esc="false"
    @md-clicked-outside="closeDialog"
  >
    <md-dialog-title
      class="md-primary md-layout md-alignment-center-space-between"
    >
      <div class="md-layout-item md-size-80">
        <div class="md-title">Archivos del concepto</div>
        <div class="md-subheading md-layout">
          <span style="margin: 5px">Concepto:</span>
          <md-chip style="max-width: 200px" class="md-primary">
            {{ concept.code }}
          </md-chip>
          <slot name="dialog-subtitle" />
        </div>
      </div>
      <div
        class="md-layout-item md-size-10 md-layout md-alignment-center-right"
      >
        <md-button @click="closeDialog" class="md-just-icon md-round md-simple">
          <md-icon>close</md-icon>
        </md-button>
      </div>
    </md-dialog-title>
    <div class="dialog-content">
      <FilesTab
        :fileTypes="fileTypes"
        :loadedFiles="files"
        :disableAll="disableAll"
        :casualty="casualty"
        @saveChanges="saveChanges"
        @openVisor="(photo) => $emit('openVisor', photo)"
      />
      <div v-if="casualty.requiredBTC" style="margin: 0 0 25px">
        <h3 class="md-layout md-alignment-center">
          Descargar formatos de generadores de trabajo (diario y final):
        </h3>
        <div class="md-layout md-alignment-center">
          <md-button
            @click="downloadWorkGenerator(concept.id, 'daily')"
            class="md-just-icon md-info"
            :disabled="
              !$can(
                'can_download_work_generator_daily',
                'Quantification',
                'quantification'
              )
            "
          >
            <md-icon>cloud_download</md-icon>
            <md-tooltip>Diario</md-tooltip>
          </md-button>
          <md-button
            @click="downloadWorkGenerator(concept.id, 'final')"
            class="md-just-icon md-info"
            :disabled="
              !$can(
                'can_download_work_generator_final',
                'Quantification',
                'quantification'
              )
            "
          >
            <md-icon>cloud_download</md-icon>
            <md-tooltip>Final</md-tooltip>
          </md-button>
        </div>
      </div>
    </div>
  </md-dialog>
</template>

<script>
import FilesTab from "./FilesTab";

import { cloneDeep } from "lodash";
import purchaseService from "@/services/purchase";

export default {
  name: "FilesModal",
  components: { FilesTab },
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    disableAll: {
      type: Boolean,
      required: true,
      default: false,
    },
    concept: {
      type: [Object, null],
      required: false,
      default: () => {},
    },
    fetchedFileTypes: {
      type: Array,
      required: true,
      default: () => [],
    },
    casualty: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      files: {},
    };
  },
  computed: {
    fileTypes() {
      const allowTypes = ["damage", "GO"];
      return this.fetchedFileTypes
        .filter((t) => allowTypes.some((a) => a === t.codename))
        .map((t) => {
          const { codename } = t;
          switch (codename) {
            case "damage":
              return {
                ...t,
                type: "image",
                allowedFormats: ["jpg", "jpeg"],
                disableCharge: () => false,
              };
            case "GO":
              return {
                ...t,
                allowedFormats: ["pdf", "xlsx", "xls"],
                disableCharge: (files) => !!files.GO && !!files.GO.length,
                singleFile: true,
              };

            default:
              return {
                ...t,
                type: "image",
                allowedFormats: ["jpg", "jpeg"],
                singleFile: true,
                disableCharge: (files) => !!files.FPD && !!files.FPD.length,
              };
          }
        });
    },
  },
  methods: {
    downloadWorkGenerator(qId, type) {
      purchaseService
        .getWorkGenerator(qId, type)
        .then(() => this.$successMessage({ title: "Archivo descardago" }))
        .catch(this.$fireErrorResponse);
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    saveChanges(toLoad, toReject, toVisible) {
      this.$emit("saveChanges", toLoad, toReject, toVisible);
    },
  },
  watch: {
    concept: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.files = {};
        if (newVal) {
          const types = this.fileTypes.reduce(
            (ac, a) => ({ ...ac, [a.codename]: [] }),
            {}
          );
          this.files = Object.assign({}, this.file, types);
          this.files.GO = newVal.files ? cloneDeep(newVal.files) : [];
          this.files.FPD = newVal.panoramicDamagePhotos
            ? cloneDeep(newVal.panoramicDamagePhotos)
            : [];
          this.files.damage = newVal.damagePhotos
            ? cloneDeep(newVal.damagePhotos)
            : [];
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-content {
  overflow: auto;
}
.md-dialog-title {
  margin: 0;
  padding: 15px;
}
.md-card {
  width: 70vw;
}
.md-card,
.md-card-content,
.md-card-actions {
  border: none;
  box-shadow: none;
}
@media (min-width: 768px) {
  .dialog-content {
    min-width: 760px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/File/Lifting/FilesModal.vue